<template>
	<md-speed-dial class="float-bottom-right" md-event="click" md-direction="top">
		<md-speed-dial-target class="md-primary">
			<md-icon class="md-morph-initial">add</md-icon>
			<md-icon class="md-morph-final">close</md-icon>
		</md-speed-dial-target>

		<md-speed-dial-content>
			<md-button
				class="md-icon-button"
				v-if="$route.params.project_id === undefined"
				@click="$emit('add', 'project')"
			>
				<font-awesome-icon icon="folder-plus" size="lg" />
				<md-tooltip md-direction="left">{{ $t("new-project") }}</md-tooltip>
			</md-button>
			<md-button
				class="md-icon-button"
				v-if="$route.params.project_id !== undefined && $route.params.folder_id === undefined"
				@click="$emit('add', 'folder')"
			>
				<font-awesome-icon icon="folder-plus" size="lg" />
				<md-tooltip md-direction="left">{{ $t("add-folder") }}</md-tooltip>
			</md-button>
			<md-button
				class="md-icon-button"
				v-if="$route.params.project_id !== undefined"
				@click="$emit('add', 'document')"
			>
				<font-awesome-icon icon="file-medical" size="lg" />
				<md-tooltip md-direction="left">{{ $t("add-doc") }}</md-tooltip>
			</md-button>
		</md-speed-dial-content>
	</md-speed-dial>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFolderPlus, faFileMedical, faProjectDiagram } from "@fortawesome/free-solid-svg-icons"

library.add(faFolderPlus)
library.add(faFileMedical)
library.add(faProjectDiagram)
export default {
	name: "floating-button"
}
</script>
